import { BouColor } from '@upright/ui/common/generic/global/bou-colors';

export const searchBackgroundColor = `${BouColor.PLATFORM_BG_GRAY_DARK};`;
